import React, { Component } from 'react';
import { connect } from 'react-redux';
import InnerPagesComponent from '../../components/InnerPagesComponent/InnerPagesComponent';
import { resetReducer } from '../../store/actions/resetReducerAction';
import { getPayments, getPaymentsLast,getPaymentsApprove,userAutocomplite,AddMoney} from '../../store/actions/PaymentActions';
import { withRouter } from 'react-router-dom';
import PaymentsComponent from '../../components/PaymentsComponent/PaymentsComponent'

class PaymentsContainer extends Component {
    componentWillUnmount() {
        this.props.resetReducer("RESET_PAYMENTS_REDUCER")
    }
    render() {
        return (
            <div>
                <InnerPagesComponent pageName="" logo={this.props.DashboardReducer.optionsData.options.logo}>
                    {this.props.DashboardReducer.permissionsFetched &&
                        <PaymentsComponent
                            PotentialsReducer={this.props.PotentialsReducer}
                            DashboardReducer={this.props.DashboardReducer}
                            resetReducer={this.props.resetReducer}
                            getPayments={this.props.getPayments}
                            paymentsReducer={this.props.paymentsReducer}
                            getPaymentsLast={this.props.getPaymentsLast}
                            getPaymentsApprove={this.props.getPaymentsApprove}
                            userAutocomplite={this.props.userAutocomplite}
                            AddMoney={this.props.AddMoney}
                        />
                    }
                </InnerPagesComponent>
            </div>
        );
    }
}

const mapStateFromProps = store => ({
    PotentialsReducer: store.PotentialsReducer,
    DashboardReducer: store.DashboardReducer,
    paymentsReducer: store.paymentsReducer
});

const mapDispatchFromProps = dispatch => ({
    resetReducer: (name) => (dispatch(resetReducer(name))),
    getPayments: (body) => (dispatch(getPayments(body))),
    getPaymentsLast: (body) => (dispatch(getPaymentsLast(body))),
    getPaymentsApprove: (body) => (dispatch(getPaymentsApprove(body))),
    userAutocomplite: (body) => (dispatch(userAutocomplite(body))),
    AddMoney: (body) => (dispatch(AddMoney(body)))
});

export default withRouter(connect(mapStateFromProps, mapDispatchFromProps)(PaymentsContainer));
